import { Controller, Control, FieldErrors } from 'react-hook-form';
import { LoanFormData } from '@/schemas/loanSchema';
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { getErrorMessage } from '@/components/formErrorMessage';

interface Props {
  control: Control<LoanFormData>;
  errors: FieldErrors<LoanFormData>;
}

export const PrepaymentTermsSection = ({ control, errors }: Props) => (
  <div className="p-8 mb-8">
    <h3 className="section-title">Prepayment Terms</h3>
    <div className="grid-2">
      <div>
        <Label
          className="form-label"
          htmlFor="prepayment_terms.prepayment_penalty_type"
        >
          Prepayment Penalty Type
        </Label>
        <Controller
          name="prepayment_terms.prepayment_penalty_type"
          control={control}
          render={({ field }) => (
            <Select onValueChange={field.onChange} value={field.value ?? ''}>
              <SelectTrigger
                error={getErrorMessage(errors, 'prepayment_penalty_type')}
              >
                <SelectValue placeholder="Select penalty type" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="Fixed">Fixed</SelectItem>
                <SelectItem value="Yield Maintenance">
                  Yield Maintenance
                </SelectItem>
              </SelectContent>
            </Select>
          )}
        />
      </div>
      <div>
        <Label
          className="form-label"
          htmlFor="prepayment_terms.prepayment_penalty_description"
        >
          Prepayment Penalty Description
        </Label>
        <Controller
          name="prepayment_terms.prepayment_penalty_description"
          control={control}
          render={({ field }) => (
            <Textarea
              {...field}
              id="prepayment_terms.prepayment_penalty_description"
              className="input-full"
              value={field.value ?? ''}
            />
          )}
        />
      </div>
    </div>
  </div>
);
